import { useState, useEffect } from "react";
import { Check, MapPin, Plane, Calendar, Sparkles, ArrowRight } from "lucide-react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { usePackages } from "../../hooks/usePackages";

export const Packages = ({
  limit = null,
  layout = "carousel"
}) => {
  const { packages, loading } = usePackages();
  const navigate = useNavigate();
const location = useLocation();

const [cityFilter, setCityFilter] = useState(
  location.pathname === "/paket-umroh-batam"
    ? "Batam"
    : location.pathname === "/paket-umroh-palembang"
    ? "Palembang"
    : "Semua"
); 
 useEffect(() => {
  if (location.pathname === "/paket-umroh-batam") {
    setCityFilter("Batam");
  } else if (location.pathname === "/paket-umroh-palembang") {
    setCityFilter("Palembang");
  } else {
    setCityFilter("Semua");
  }
}, [location.pathname]);

const getWhatsAppNumber = (city) => {
  const c = (city || "").toLowerCase();

  if (c.includes("palembang")) {
    return "62811713309";
  }

  return "6282392156538";
}; 
const filteredPackages =
  cityFilter === "Semua"
    ? packages
    : packages.filter(
        (p) =>
          (p.departureCity || "").trim().toLowerCase() ===
          cityFilter.toLowerCase()
      );

const displayedPackages = limit
  ? filteredPackages.slice(0, limit)
  : filteredPackages;

console.log(
  "PACKAGES",
  packages.map((p) => ({
    id: p.id,
    departureCity: p.departureCity,
  }))
);

console.log("FILTER", cityFilter);

console.log("FILTERED", filteredPackages.length);

let pageTitle = "Paket Umroh Batam & Palembang 2027";
let pageDesc =
  "Temukan berbagai pilihan paket umroh keberangkatan Batam dan Palembang dengan maskapai terpercaya, hotel pilihan di Makkah dan Madinah, serta pendamping ibadah berpengalaman dari Baba Tour.";

if (cityFilter === "Batam") {
  pageTitle = "Paket Umroh Batam 2027";
  pageDesc =
    "Pilihan paket umroh keberangkatan Batam dengan berbagai jadwal, maskapai terpercaya, hotel pilihan, dan pendamping ibadah berpengalaman.";
}

if (cityFilter === "Palembang") {
  pageTitle = "Paket Umroh Palembang 2027";
  pageDesc =
    "Pilihan paket umroh keberangkatan Palembang dengan berbagai jadwal, maskapai terpercaya, hotel pilihan, dan pendamping ibadah berpengalaman.";
}

  return (
    <section
      id="packages"
      data-testid="packages-section"
      className="py-24 md:py-32 bg-surface"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
	  <div className="max-w-4xl">
          <div className="text-sm uppercase tracking-[0.22em] text-accent font-semibold">
            Paket Perjalanan
          </div>
          <h2 className="font-serif-display text-primary text-4xl sm:text-5xl mt-4 leading-tight">
				{pageTitle}
          </h2>
          <p className="text-muted mt-5 leading-relaxed">
				{pageDesc}
          </p>
	  <p className="text-muted mt-4 leading-relaxed text-sm">
  Baba Tour menyediakan paket umroh keberangkatan Batam dan Palembang dengan
  berbagai pilihan jadwal sepanjang tahun. Pilih kota keberangkatan untuk
  melihat paket yang tersedia sesuai kebutuhan perjalanan ibadah Anda.
	  </p>
<div className="mt-8 flex gap-3 flex-wrap">
  {["Semua", "Batam", "Palembang"].map((city) => (
    <button
      key={city}
      onClick={() => {
  if (city === "Batam") {
    navigate("/paket-umroh-batam");
  } else if (city === "Palembang") {
    navigate("/paket-umroh-palembang");
  } else {
    navigate("/paket-umroh");
  }
}}
      className={`px-5 py-2 rounded-full text-sm font-medium transition ${
        cityFilter === city
          ? "bg-primary text-white"
          : "bg-white border border-soft text-primary"
      }`}
    >
      {city}
    </button>
  ))} </div>
{layout === "carousel" && (
  <div className="mt-6">
    <Link
      to="/paket-umroh"
      className="inline-flex items-center gap-2 bg-primary text-white px-5 py-3 rounded-full text-sm font-medium hover:bg-primary/90 transition"
    >
      Lihat Semua Paket →
    </Link>
  </div>
)}
        </div>

	{layout === "carousel" && (
	  <div className="mt-4 text-center text-sm text-muted">
   		 ← Geser untuk melihat paket lainnya →
  	</div>
)}

        {loading ? (
  <div className="mt-16 text-center text-muted">
    Memuat paket...
  </div>
        ) : (
	<div
  className={
    layout === "grid"
      ? "mt-6 grid grid-cols-2 lg:grid-cols-3 gap-4"
      : "mt-6 flex gap-7 overflow-x-auto snap-x snap-mandatory pb-4"
  }
>
	   { displayedPackages.map((p) => (
              <article
                key={p.id}
                data-testid={`package-${p.id}-card`}
className={`bg-[color:var(--bg)] border border-soft rounded-2xl overflow-hidden lift ${
  layout === "grid"
    ? ""
    : "min-w-[260px] md:min-w-[280px] snap-center"
}`}
              >
		<div className={`relative overflow-hidden ${
  layout === "grid" ? "h-36" : "h-64"
}`}>
                  <img
                    src={p.image}
                    alt={p.name}
                    className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                  />
<div
  className={`absolute bg-accent text-white uppercase font-semibold ${
    layout === "grid"
      ? "top-2 left-2 text-[9px] px-2 py-1 rounded"
      : "top-4 left-4 text-[11px] tracking-[0.18em] px-3 py-1.5 rounded-full"
  }`}
>
                    {p.badge}
                  </div>
<div className="absolute bottom-4 right-4 bg-black/60 backdrop-blur rounded-full px-4 py-2 text-xs">
<span className="text-white/80">Mulai dari</span>
<span
  className={`font-serif-display text-white ml-1 ${
    layout === "grid" ? "text-xs" : "text-base"
  }`}
>
                      {p.priceFrom}
                    </span>
                  </div>
                </div>
		  <div className={layout === "grid" ? "p-4" : "p-7 md:p-9"}>
		  <h3 className={`font-serif-display text-primary ${
  layout === "grid" ? "text-lg" : "text-3xl"
}`}>
                    {p.name}
                </h3>
<div
  className={`mt-2 inline-flex items-center border border-soft ${
    layout === "grid"
      ? "text-[10px] px-2 py-0.5 rounded"
      : "text-xs px-3 py-1 rounded-full"
  }`}
>
                  📍 {p.departureCity}
                </div>	
		<div className={`mt-4 grid grid-cols-2 gap-2 text-muted ${
  layout === "grid" ? "text-[11px]" : "text-xs"
}`}
>
                    <div className="flex items-center gap-2">
			<Calendar
  className={`text-accent shrink-0 ${
    layout === "grid"
      ? "w-4 h-4"
      : "w-3.5 h-3.5"
  }`}
/>
                      {p.duration}
                    </div>
                    <div className="flex items-center gap-2">
			<Plane
  className={`text-accent shrink-0 ${
    layout === "grid"
      ? "w-4 h-4"
      : "w-3.5 h-3.5"
  }`}
/>
                      {p.airline}
                    </div>
                    <div className="flex items-center gap-2 col-span-2">
			<MapPin
  className={`text-accent shrink-0 ${
    layout === "grid"
      ? "w-4 h-4"
      : "w-3.5 h-3.5"
  }`}
/>
                      {p.departures}
                    </div>
                  </div>
<div className={`flex gap-1 ${
  layout === "grid" ? "text-[11px]" : "text-main"
}`}>
  <Sparkles className="w-4 h-4 text-accent shrink-0 mt-0.5" />
  <span>
    {p.hotelMakkah}
    {p.hotels?.find(h => h.location === "Makkah")?.rating
      ? ` ${"★".repeat(
          p.hotels.find(h => h.location === "Makkah").rating
        )}`
      : ""}
  </span>
</div>

<div className={`flex gap-1 ${
  layout === "grid" ? "text-[11px]" : "text-main"
}`}>

  <Sparkles className="w-4 h-4 text-accent shrink-0 mt-0.5" />
  <span>
    {p.hotelMadinah}
    {p.hotels?.find(h => h.location === "Madinah")?.rating
      ? ` ${"★".repeat(
          p.hotels.find(h => h.location === "Madinah").rating
        )}`
      : ""}
  </span>
</div>

		<ul className={layout === "grid" ? "mt-3 space-y-1.5" : "mt-6 space-y-2.5"}>
  {(layout === "grid"
    ? (p.includes || []).slice(0, 2)
    : (p.includes || []).slice(0, 4)
  ).map((inc) => (
                      <li
                        key={inc}
className={`flex items-start gap-2.5 text-muted ${
  layout === "grid" ? "text-xs" : "text-sm"
}`}
                      >
                        <Check className="w-4 h-4 text-primary shrink-0 mt-0.5" />
                        <span>{inc}</span>
                      </li>
                    ))}
                  </ul>
			<div
  className={`mt-4 ${
    layout === "grid"
      ? "flex flex-col gap-2"
      : "flex items-center gap-3"
  }`}
>
                    <Link
                      to={`/packages/${p.id}`}
                      data-testid={`package-${p.id}-detail`}
		className={`bg-primary text-white hover:bg-primary/90 transition rounded-full font-medium flex-1 text-center inline-flex items-center justify-center gap-2 ${
  layout === "grid"
    ? "px-3 py-2 text-xs"
    : "px-6 py-3 text-sm"
}`}
                    >
                      Lihat Detail <ArrowRight className="w-4 h-4" />
                    </Link>
                    <a
  href={`https://wa.me/${getWhatsAppNumber(
    p.departureCity
  )}?text=${encodeURIComponent(
`Assalamu'alaikum Baba Tour.

Saya tertarik dengan paket ${p.name}.

Kota keberangkatan: ${p.departureCity}

Mohon informasi mengenai:
- Jadwal keberangkatan
- Ketersediaan seat
- Hotel yang digunakan
- Cara pembayaran

Terima kasih.`
)}`}
                      target="_blank"
                      rel="noreferrer"
                      data-testid={`package-${p.id}-wa`}
                      className="border border-soft text-primary hover:bg-surface transition rounded-full px-6 py-3 text-sm font-medium"
                    >
                      Konsultasi
                    </a>
                  </div>
</div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
